import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface BreadCrumb {
  key: string;
  value: string;
}

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss',],
})
export class BreadCrumbComponent {

  breadCrumbs: BreadCrumb[] = [];

  constructor(private _router: Router) {
    this._router.events
      .subscribe({
        next: (event: any) => {
          const { url, } = event;
          if (!url) return;
          const [urls,] = url.split('?');
          // HOME / CARS
          this.breadCrumbs = [{ key: 'home', value: '', }, { key: 'cars', value: '', },];
          if (!urls.startsWith('/cars')) {
            const [, second, third,] = urls.split('/');
            /**
             * /brand/maruti-suzuki-car-subscription
             * we don't have a separate page for brand so redirect to cars 
             */
            // eslint-disable-next-line no-magic-numbers
            if (second) this.breadCrumbs[1] = { key: second, value: 'cars', };

            if (third) {
              const [lastNew,] = third.split('-car');
              // Split and join - MARUTI-SUZUKI -> MARUTI-SUZUKI
              if (lastNew) this.breadCrumbs.push({ key: lastNew.split('-').join(' '), value: '', });
            }
          }
        },
      });
  }
}
